module.exports = __webpack_public_path__ + "img/2.a9e6240d.jpg";